import { render } from "./PopupManageListPage.vue?vue&type=template&id=10db6dc1&lang=true"
import script from "./PopupManageListPage.vue?vue&type=script&lang=js"
export * from "./PopupManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__